import "./bootstrap";

import { createInertiaApp, router } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createApp, h } from "vue";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import { route } from "ziggy-js";
import "primeicons/primeicons.css";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import { i18nVue } from "laravel-vue-i18n";
import Tooltip from "primevue/tooltip";
import VueTelInput from "vue3-tel-input";
import VueDraggableResizable from "vue-draggable-resizable";
import VueSmoothScroll from "vue3-smooth-scroll";
import Vue3autocounter from "vue3-autocounter";
import "vue3-tel-input/dist/vue3-tel-input.css";
import VueVideoPlayer from "@videojs-player/vue";
import "video.js/dist/video-js.css";
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/style.css";

// PerfectScrollbar passive event listener configuration
const perfectScrollbarConfig = {
    globalOptions: {
        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        wheelSpeed: 1,
        touchSensitivity: 1,
        swipeEasing: true,
    },
};

import { SwipeList, SwipeOut } from "vue3-swipe-actions";
import bottomNavigationVue from "bottom-navigation-vue";
import "bottom-navigation-vue/dist/style.css";

import { MyPreset } from "./theme";
import uppercase from "./uppercase";

// Configure passive event listeners for better performance
if (typeof window !== "undefined") {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (
        type,
        listener,
        options
    ) {
        if (type === "touchstart" || type === "touchmove" || type === "wheel") {
            if (typeof options === "boolean") {
                options = { capture: options, passive: true };
            } else if (typeof options === "object" && options !== null) {
                options.passive = options.passive !== false;
            } else {
                options = { passive: true };
            }
        }
        return originalAddEventListener.call(this, type, listener, options);
    };
}

// Inertia router scroll davranışını yönet
router.on("start", (event) => {
    // Tab navigation için scroll pozisyonunu koru
    if (event.detail.visit.url.pathname.includes("/tr/")) {
        const currentScrollY = window.scrollY;
        event.detail.visit.preserveScroll = currentScrollY < 100; // Üst kısımdaysa scroll preserve
    }
});

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(VueSmoothScroll)
            .use(VueVideoPlayer)
            .use(PrimeVue, {
                ripple: true,
                theme: {
                    preset: MyPreset,
                    options: {
                        prefix: "p",
                        darkModeSelector: ".dark",
                        // cssLayer: {
                        //     name: "primevue",
                        //     order: "tailwind-base, primevue, tailwind-utilities",
                        // },
                    },
                },
            })
            .use(ToastService)
            .use(ConfirmationService)
            .use(PerfectScrollbarPlugin, perfectScrollbarConfig)
            .use(bottomNavigationVue)
            .use(i18nVue, {
                resolve: (lang) => {
                    // Laravel 11+: lang dosyaları "lang/" klasöründe (root)
                    const messages = import.meta.glob("/lang/*.json", {
                        eager: true,
                    });
                    return messages[`/lang/${lang}.json`].default;
                },
            })
            .use(VueTelInput)
            .component("swipe-list", SwipeList)
            .component("swipe-out", SwipeOut)
            .component("vue-draggable-resizable", VueDraggableResizable)
            .component("vue3-autocounter", Vue3autocounter);
        app.directive("tooltip", Tooltip);
        app.directive("uppercase", uppercase);
        app.config.globalProperties.$route = route;
        delete el.dataset.page;
        return app.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
